<!-- 轮播图带字 -->
<template>
  <div class="banner">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" :key="i" v-for="item,i in bannerLists"><img style="width: 100%; height: 100%;" :src="item.avatar" @click="linkNewDetail(item.id)" />
            <div class="swiper-text">
                <div class="swiper-left">
                    {{item.title}}
                </div>
                <div class="swiper-right">
                   {{(i+1)+'/'+(bannerLists.length)}}
                </div>
            </div>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <!-- 如果需要滚动条 -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Banner',
    props:{
      banners:{
        type: Array,//传参类型
        default: [],//默认参数
      }
    },
    watch: {
        banners: {
            handler: function(newVal, oldVal) {
                this.bannerLists = [...newVal ]
                // console.log(2,this.bannerLists )
                this.$nextTick(() => {
                    var mySwiper = new this.Swiper('.swiper-container', {
                        loop: true, // 循环模式选项
                        effect: 'fade',
                        type: 'bullets',
                        autoplay: {delay: 2000,stopOnLastSlide: false,disableOnInteraction: true},
                        // 如果需要分页器
                        pagination: { el: '.swiper-pagination', dynamicBullets: true},
                        // 如果需要前进后退按钮
                        navigation: {nextEl: '.swiper-button-next',prevEl: '.swiper-button-prev'},
                        // 如果需要滚动条
                        scrollbar: {el: '.swiper-scrollbar'}
                    });
                });
            },
        }
    },
    data() {
      return {
        bannerLists: [],
      };
    },
    mounted() {
    
    },
    methods:{
      //跳转到新闻资讯详情
      linkNewDetail(id){
        this.$router.push({ path: '/messageDetail', query: { id: id } });
      },
    },
  };
</script>

<style scoped>
  .swiper-container {--swiper-theme-color: #ffffff;--swiper-navigation-color: #ffffff;--swiper-navigation-size: 50px; width: 100%; height: 100%; }
  .banner {min-width: 100%; height: 460px;}
  .swiper-text{z-index: 99;position: absolute;bottom: 0px;background:rgba(0,0,0,0.34);width: 100%;display: flex;font-size: 14px;justify-content: space-between;padding: 15px;color: #fff;}
</style>


// WEBPACK FOOTER //
// src/components/Banners.vue